export const buildAccountUrl = (accountId: string) =>
	`/secure/ViewProfile.jspa?accountId=${accountId}`;
